export default __webpack_public_path__ + "static/Maunfacturing-Photo2-552233377087e9e7e1451cb0374449c2.png";